import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class HotelContact extends React.Component {
  constructor(props) {
    super(props);
    this.handleSend = this.handleSend.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  handleRemove(e) {
    e.preventDefault();
    this.props.removeHotelContact(this.props.hotelId, { user: this.props.contact.id });
  }
  handleSend(e) {
    e.preventDefault();
    this.props.addHotelContact(this.props.hotelId, { user: this.props.contact.id });
  }
  buildToolbar() {
    if (this.props.readOnly) {
      return null;
    }
    return (
      <span className="pull-right">
        <Button onClick={this.handleSend} title="Resend invite">
          <i className="fa fa-refresh" />
        </Button>
        <Button onClick={this.handleRemove} title="Remove contact">
          <i className="fa fa-trash" />
        </Button>
      </span>
    );
  }
  render() {
    const contact = this.props.contact;
    const toolbar = this.buildToolbar();
    if (contact) {
      if (contact.first_name) {
        return (
          <h4 className="clearfix">
            {contact.first_name} {contact.last_name} {toolbar}
          </h4>
        );
      }
      return (
        <p className="clearfix">
          {contact.email} {toolbar}
        </p>
      );
    }
    return <p>Hotel Contact missing.</p>;
  }
}
HotelContact.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  hotelId: PropTypes.string.isRequired,
  contact: PropTypes.object.isRequired,
  removeHotelContact: PropTypes.func.isRequired,
  addHotelContact: PropTypes.func.isRequired,
};
export default HotelContact;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelContact.js